import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, Globe, Laptop, Briefcase } from 'lucide-react';
export function BackgroundFX() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-24">
      {/* 1. Subtle Diagonal Sweep */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-black/[0.4]" data-id="element-25" />

      {/* 2. Animated Dot Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(#F5B942 1.5px, transparent 1.5px)',
      backgroundSize: '32px 32px'
    }} data-id="element-26" />

      {/* 3. Large Soft Ambient Blobs (Pulsing) */}
      {/* Top Left - Gold */}
      <motion.div animate={{
      scale: [1, 1.1, 1],
      opacity: [0.06, 0.09, 0.06]
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -top-[20%] -left-[10%] w-[60vw] h-[60vw] rounded-full bg-electric blur-[150px]" data-id="element-27" />

      {/* Middle Right - Neon Green (USD/Energy) */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.04, 0.07, 0.04]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute top-[30%] -right-[15%] w-[50vw] h-[50vw] rounded-full bg-energy blur-[150px]" data-id="element-28" />

      {/* Bottom Left - Gold */}
      <motion.div animate={{
      scale: [1, 1.15, 1],
      opacity: [0.05, 0.08, 0.05]
    }} transition={{
      duration: 14,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 5
    }} className="absolute -bottom-[10%] -left-[20%] w-[70vw] h-[70vw] rounded-full bg-electric blur-[150px]" data-id="element-29" />

      {/* 4. Horizon Glow Band (Bottom) */}
      <div className="absolute bottom-0 left-0 right-0 h-[25vh] bg-gradient-to-t from-energy/[0.04] to-transparent blur-[40px]" data-id="element-30" />

      {/* 5. Subtle Floating Digital Business Icons */}
      <motion.div animate={{
      y: [0, -20, 0],
      rotate: [0, 5, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-[15%] left-[10%] text-electric opacity-[0.03]" data-id="element-31">
        <DollarSign className="w-32 h-32" data-id="element-32" />
      </motion.div>

      <motion.div animate={{
      y: [0, 25, 0],
      rotate: [0, -10, 0]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute top-[45%] right-[8%] text-energy opacity-[0.02]" data-id="element-33">
        <TrendingUp className="w-40 h-40" data-id="element-34" />
      </motion.div>

      <motion.div animate={{
      y: [0, -15, 0],
      rotate: [0, 8, 0]
    }} transition={{
      duration: 9,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 3
    }} className="absolute bottom-[25%] left-[15%] text-electric opacity-[0.02]" data-id="element-35">
        <Globe className="w-24 h-24" data-id="element-36" />
      </motion.div>

      <motion.div animate={{
      y: [0, 20, 0],
      rotate: [0, -5, 0]
    }} transition={{
      duration: 11,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute top-[70%] right-[20%] text-electric opacity-[0.02]" data-id="element-37">
        <Briefcase className="w-28 h-28" data-id="element-38" />
      </motion.div>

      <motion.div animate={{
      y: [0, -30, 0],
      rotate: [0, 12, 0]
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 4
    }} className="absolute top-[25%] right-[25%] text-energy opacity-[0.02]" data-id="element-39">
        <Laptop className="w-20 h-20" data-id="element-40" />
      </motion.div>
    </div>;
}